import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Home, Blogs, Experience, Travel, About } from "./pages/index";
import Nav from './components/Nav'
import './App.css';
import {ThemeProvider} from './context/context'

function App() {
  return (
    <div className="App">
      <Router>
      <ThemeProvider>
        <Nav/>
        <Switch>
          <Route exact path="/" component={Home}></Route>
          <Route exact path="/about" component={About}></Route>
          <Route exact path="/experience" component={Experience}></Route>
          <Route exact path="/blogs" component={Blogs}></Route>
          <Route exact path="/travel" component={Travel}></Route>
        </Switch>
        </ThemeProvider>
      </Router>
    </div>
  );
}

export default App;
